import React, { useState, useCallback } from 'react';
import Menu from '@material-ui/icons/Menu';
import GridModalDetails from '../GridModalDetails';

import './index.scss';

export interface ParamModalDetails {
  pv: number | undefined;
  nomePv?: string;
  cnpjPv?: string;
}

const ButtonGrid: React.FC<ParamModalDetails> = ({ pv, nomePv, cnpjPv}) => {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  return (
    <>
      <button className="button-modal" onClick={handleOpen}>
        <Menu color="action" style={{ fontSize: 18 }} />
      </button>
      <GridModalDetails
        pv={pv}
        nomePv={nomePv}
        cnpjPv={cnpjPv}
        open={open}
        handleClose={handleClose}
      />
    </>
  );
};

export default ButtonGrid;
